import { Spinner } from "@win-reality/react-ui";

import smartparkLogo from "@/assets/smartpark-logo-black.png";

export const LoadingScreen = () => {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-8 bg-background">
      <img src={smartparkLogo} className="h-16 w-auto" alt="SmartPark logo" />
      <Spinner size="screen" />
    </div>
  );
};
